import APIClient from '@/shared/http/clients/api'

const resourceName = 'REUnidadeTipo'
const APIBaseURLRealEstate = process.env.APIBaseURLRealEstate

const GetAllByEmpreendimento = (id, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetAllByEmpreendimento/${id}`, data, config)
const NewType = (id, data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/NewByEmpreendimentoId/${id}`, data, config)
const RemoveImage = (id, data = {}, config = {}) => APIClient.put(`${APIBaseURLRealEstate}/${resourceName}/RemoveImage/${id}`, data, config)
const RemovePdf = (id, data = {}, config = {}) => APIClient.delete(`${APIBaseURLRealEstate}/${resourceName}/RemovePDF/${id}`, data, config)
const SaveArquivo = (unidadetipoid, empreendimentoid, data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/SaveArquivo/${unidadetipoid}/${empreendimentoid}`, data, {
  ...config,
  transformRequest: [(d, headers) => {
    delete headers['Content-Type']
    return d
  }]
})
const SaveArquivoTabPrec = (unidadetipoid, empreendimentoid, data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/SaveArquivoTabPrec/${unidadetipoid}/${empreendimentoid}`, data, {
  ...config,
  transformRequest: [(d, headers) => {
    delete headers['Content-Type']
    return d
  }]
})
const GetPlantasByEmpreendimentoIdMidias = (id, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetPlantasByEmpreendimentoIdMidias/${id}`, data, config)
const GetArquivo = (id, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetArquivo/${id}`, data, config)
const GetArquivoTabPrec = (id, unidadeTipoId, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetArquivoTabPrec/${id}/${unidadeTipoId}`, data, config)

const UnityPriseRepository = {
  GetAllByEmpreendimento,
  NewType,
  RemoveImage,
  SaveArquivo,
  SaveArquivoTabPrec,
  GetPlantasByEmpreendimentoIdMidias,
  GetArquivo,
  RemovePdf,
  GetArquivoTabPrec

}

export default UnityPriseRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/realestate/unitytype.js